import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getNavActiveIndex } from '../config/navConfig';
import ServicesMegaMenu from './ServicesMegaMenu';
import ProductsMegaMenu from './ProductsMegaMenu';
import './GooeyNav.css';

const HOVER_CLOSE_DELAY = 180;

// Map a mega-menu nav label to the component that renders its panel.
const MEGA_MENUS = {
  Services: ServicesMegaMenu,
  Products: ProductsMegaMenu,
};

const GooeyNav = ({ items }) => {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(() => getNavActiveIndex(location.pathname));
  // Label of the currently open mega-menu, or null.
  const [openMega, setOpenMega] = useState(null);
  const closeTimerRef = useRef(null);

  useEffect(() => {
    setActiveIndex(getNavActiveIndex(location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    setOpenMega(null);
  }, [location.pathname]);

  const openMegaMenu = (label) => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setOpenMega(label);
  };

  const closeMegaMenu = () => {
    closeTimerRef.current = setTimeout(() => {
      setOpenMega(null);
    }, HOVER_CLOSE_DELAY);
  };

  useEffect(() => () => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
  }, []);

  const OpenMenu = openMega ? MEGA_MENUS[openMega] : null;

  return (
    <div
      className={`gooey-nav-container ${openMega ? 'mega-open' : ''}`}
      onMouseLeave={closeMegaMenu}
    >
      <nav>
          <ul>
            {items.map((item, index) => {
              const isMega = item.megaMenu && MEGA_MENUS[item.label];

              if (isMega) {
                return (
                  <li
                    key={item.href}
                    className={`nav-item-mega ${activeIndex === index || openMega === item.label ? 'active' : ''}`}
                    onMouseEnter={() => openMegaMenu(item.label)}
                  >
                    <Link to={item.href}>
                      {item.label}
                      <span className="nav-chevron" aria-hidden="true">▾</span>
                    </Link>
                  </li>
                );
              }

              return (
                <li
                  key={item.href}
                  className={activeIndex === index ? 'active' : ''}
                >
                  <Link to={item.href}>{item.label}</Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {OpenMenu && (
          <div
            onMouseEnter={() => openMegaMenu(openMega)}
            onMouseLeave={closeMegaMenu}
          >
            <OpenMenu open />
          </div>
        )}
      </div>
  );
};

export default GooeyNav;
